import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const IxProximitySection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const text = report.interconnectionAnalysis?.ixProximity;
  const hasData = typeof text === 'string' && text.trim().length > 0;
  return (
    <SectionShell label={label} hasData={hasData}>
      {hasData && (
        <EditorialSubsection theme={theme} label="IX proximity">{text}</EditorialSubsection>
      )}
    </SectionShell>
  );
};
